import { withNamespaces } from "react-i18next";
import { deadlinesDiffer, formatDeadlineDate } from "../../utils";

const ResponseDeadline = ({ t, workflow }) => {
  const originalDeadline = workflow?.dsr_deadline_at;
  const effectiveDeadline = workflow?.effective_deadline_at;
  const isAdjusted = deadlinesDiffer(originalDeadline, effectiveDeadline);

  return (
    <div className="dsr-deadline-card__pair">
      <div className="dsr-deadline-card__pair-item">
        <div className="dsr-deadline-card__label">{t("Original deadline")}</div>
        <div className="dsr-deadline-card__value dsr-deadline-card__value--strong">
          {formatDeadlineDate(originalDeadline)}
        </div>
        <div className="dsr-deadline-card__hint">{t("30 days from submission")}</div>
      </div>
      <div className="dsr-deadline-card__pair-item">
        <div className="dsr-deadline-card__label d-flex align-items-center flex-wrap gap-2">
          {t("Effective deadline")}
          {!isAdjusted && (
            <span className="dsr-deadline-meta-badge">{t("Unchanged")}</span>
          )}
        </div>
        <div className="dsr-deadline-card__value dsr-deadline-card__value--strong">
          {formatDeadlineDate(effectiveDeadline)}
        </div>
        <div className="dsr-deadline-card__hint">
          {t("No formal extension applied.")}
        </div>
      </div>
    </div>
  );
};

export default withNamespaces()(ResponseDeadline);
